/**
 * 业务常量
 * 职责：业务相关枚举、状态等
 */

// ==================== 标签状态 ====================

export const LABEL_STATUS = {
  DRAFT: 'draft',           // 草稿
  PUBLISHED: 'published',   // 已发布
  ARCHIVED: 'archived',     // 已归档
  DELETED: 'deleted',       // 已删除
};

export const LABEL_STATUS_NAMES = {
  [LABEL_STATUS.DRAFT]: '草稿',
  [LABEL_STATUS.PUBLISHED]: '已发布',
  [LABEL_STATUS.ARCHIVED]: '已归档',
  [LABEL_STATUS.DELETED]: '已删除',
};

// ==================== 用户类型 ====================

export const USER_TYPE = {
  INDIVIDUAL: 'individual',   // 个人用户（前端显示用）
  ENTERPRISE: 'enterprise',    // 企业用户（前端显示用）
};

// 用户类型映射：前端字符串 -> 后端数字
export const USER_TYPE_TO_BACKEND = {
  [USER_TYPE.INDIVIDUAL]: 1,   // 1-个人用户
  [USER_TYPE.ENTERPRISE]: 2,   // 2-企业用户
};

// 后端数字 -> 前端字符串
export const USER_TYPE_FROM_BACKEND = {
  1: USER_TYPE.INDIVIDUAL,
  2: USER_TYPE.ENTERPRISE,
};

export const USER_TYPE_NAMES = {
  [USER_TYPE.INDIVIDUAL]: '个人用户',
  [USER_TYPE.ENTERPRISE]: '企业用户',
};

// ==================== 用户角色 ====================

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',     // 超级管理员
  ADMIN: 'admin',                 // 管理员
  ENTERPRISE_ADMIN: 'ent_admin',  // 企业管理员
  USER: 'user',                   // 普通用户
  GUEST: 'guest',                 // 访客
};

export const USER_ROLE_NAMES = {
  [USER_ROLES.SUPER_ADMIN]: '超级管理员',
  [USER_ROLES.ADMIN]: '管理员',
  [USER_ROLES.ENTERPRISE_ADMIN]: '企业管理员',
  [USER_ROLES.USER]: '普通用户',
  [USER_ROLES.GUEST]: '访客',
};

// ==================== 用户状态 ====================

export const USER_STATUS = {
  ACTIVE: 'active',       // 激活
  INACTIVE: 'inactive',   // 未激活
  DISABLED: 'disabled',   // 禁用
  DELETED: 'deleted',     // 已删除
};

export const USER_STATUS_NAMES = {
  [USER_STATUS.ACTIVE]: '正常',
  [USER_STATUS.INACTIVE]: '未激活',
  [USER_STATUS.DISABLED]: '已禁用',
  [USER_STATUS.DELETED]: '已删除',
};

// ==================== 企业审核状态 ====================

export const ENTERPRISE_AUDIT_STATUS = {
  PENDING: 'pending',     // 待审核
  APPROVED: 'approved',   // 已通过
  REJECTED: 'rejected',   // 已拒绝
};

export const ENTERPRISE_AUDIT_STATUS_NAMES = {
  [ENTERPRISE_AUDIT_STATUS.PENDING]: '待审核',
  [ENTERPRISE_AUDIT_STATUS.APPROVED]: '已通过',
  [ENTERPRISE_AUDIT_STATUS.REJECTED]: '已拒绝',
};

// ==================== 文件类型 ====================

export const FILE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  DOCUMENT: 'document',
  OTHER: 'other',
};

export const FILE_TYPE_NAMES = {
  [FILE_TYPES.IMAGE]: '图片',
  [FILE_TYPES.VIDEO]: '视频',
  [FILE_TYPES.AUDIO]: '音频',
  [FILE_TYPES.DOCUMENT]: '文档',
  [FILE_TYPES.OTHER]: '其他',
};

// ==================== 合规检测结果 ====================

export const COMPLIANCE_RESULT = {
  PASS: 'pass',           // 通过
  WARNING: 'warning',     // 警告
  FAIL: 'fail',           // 不通过
};

export const COMPLIANCE_RESULT_NAMES = {
  [COMPLIANCE_RESULT.PASS]: '通过',
  [COMPLIANCE_RESULT.WARNING]: '警告',
  [COMPLIANCE_RESULT.FAIL]: '不通过',
};

// ==================== 操作类型 ====================

export const OPERATION_TYPES = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  PUBLISH: 'publish',
  CLONE: 'clone',
  EXPORT: 'export',
  IMPORT: 'import',
};

export const OPERATION_TYPE_NAMES = {
  [OPERATION_TYPES.CREATE]: '创建',
  [OPERATION_TYPES.UPDATE]: '更新',
  [OPERATION_TYPES.DELETE]: '删除',
  [OPERATION_TYPES.PUBLISH]: '发布',
  [OPERATION_TYPES.CLONE]: '克隆',
  [OPERATION_TYPES.EXPORT]: '导出',
  [OPERATION_TYPES.IMPORT]: '导入',
};

// ==================== 排序方式 ====================

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SORT_FIELDS = {
  CREATE_TIME: 'createTime',
  UPDATE_TIME: 'updateTime',
  NAME: 'name',
  SIZE: 'size',
};

// ==================== 语言 ====================

export const LANGUAGES = {
  ZH_CN: 'zh-CN',
  EN_US: 'en-US',
};

export const LANGUAGE_NAMES = {
  [LANGUAGES.ZH_CN]: '简体中文',
  [LANGUAGES.EN_US]: 'English',
};

// ==================== 时间格式 ====================

export const DATE_FORMATS = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm:ss',
  DATETIME: 'YYYY-MM-DD HH:mm:ss',
  DATETIME_SHORT: 'YYYY-MM-DD HH:mm',
  MONTH: 'YYYY-MM',
  YEAR: 'YYYY',
};

// ==================== 正则表达式 ====================

export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^1[3-9]\d{9}$/,
  URL: /^https?:\/\/.+/,
  NUMBER: /^\d+$/,
  DECIMAL: /^\d+(\.\d+)?$/,
  PASSWORD: /^(?=.*[a-zA-Z])(?=.*\d).{6,20}$/,
};

